<template>
  <div class="entry">
    <van-button
      type="info"
      size="large"
      color="#cccccc"
      :style="{ 'margin-bottom': '20px'  }"
      @click="to(item.transportType)"
      v-for="(item, index) in total"
      :key="index"
      >{{ item.transportType }}({{ item.qty || 0 }})</van-button
    >
  </div>
</template>

<script>
import { Icon, Toast, Button } from "vant";
import { getloadingCount } from "@/api/mobile/loading_api";
export default {
  data() {
    return {
      total: {},
    };
  },

  components: {
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Button.name]: Button,
  },

  created() {
    this.getloadingCount();
  },

  computed: {},

  methods: {
    to(transportType) {
      this.$router.push({ path: "/mobile/loading", query: { transportType } });
    },
    getloadingCount() {
      const _warehouse = JSON.parse(window.localStorage.warehouse);

      const data = {
        warehouseId: _warehouse.warehouseId,
      };

      getloadingCount(data).then((res) => {
        if (res.status === 200 && res.success) {
          this.total = res.response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
  },

  watch: {
    $route: async function (newValue, from) {
      this.$nextTick(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.entry {
  padding: 30% 10%;
  box-sizing: border-box;
}
::v-deep .van-button__content {
  color: #5f5f5f;
}
</style>